import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import SocialLinks from "./social-links"

const Header = ({ siteTitle }) => {
  const data = useStaticQuery(graphql`
  query{
    logo: file(relativePath: { eq: "Zoom_Logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 783) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
  }
  `)
  return(
    <header>
      <div className={`header-logo`}>
        <div className={`logo`}>
          <Img fluid={data.logo.childImageSharp.fluid}/>
        </div>
        <div className={`header-slogan`}>
          <p>Achieving Success Through People.</p>
        </div>
      </div>
      <div className={`header-social`}>
        <SocialLinks color={`_w`} type={`header`}/>
      </div>
    </header>
  )
}


export default Header
